import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface AddButtonLinkProps {
  to?: string;
  name?: string;
}

export function AddButtonLink(props: AddButtonLinkProps) {
  const { to, name } = props;
  const { t } = useTranslation();

  return (
    <Button
      leftSection={<IconPlus size={16} />}
      component={Link}
      to={to ?? 'create'}
    >
      {name ?? t('button.add')}
    </Button>
  );
}
